<template>
  <div class="section-parameter">
    <div class="col-left">
      <h2>Campaign</h2>
    </div>
    <div class="col-right" v-if="campaigns.length > 0">
      <div v-for="campaign in campaigns" :key="campaign.id">
        <campaign :id="campaign.id"></campaign>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import campaign from '@/components/settings/translations/translations_campaign'

export default {
  components: { campaign },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('campaigns', {
      'campaigns': 'campaigns'
    })
  },
  methods: {
    ...mapActions('campaigns', ['loadCampaign']),

    init () {
      if (this.site) {
        this.loadCampaign()
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_campaigns.vue